export default __webpack_public_path__ + "static/media/lab-section.2d90999e.jpg";